import { recordToLang } from '../../utils';
import startPage from './startPage';
import campaign from './campaign';
import campaignRequest from './campaignRequest';

const lang: Record<string, string> = recordToLang({
    startPage,
    campaign,
    campaignRequest,
});

export default lang;
